import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private storage: Storage
  ) {
    this.init().then();
  }

  async init() {
    this.storage = await this.storage.create();
  }

  async language(lng: string = null) {
    return await this.setGet('language', lng);
  }

  async appMenu(menu: any = null) {
    return await this.setGet('menu', menu);
  }

  private async setGet(key: string, value: any = null) {
    if (value === null) {
      return await this.storage.get(key);
    } else {
      return await this.storage.set(key, value);
    }
  }
}
